<template>
    <ul class="switch-tab-wrapper">
        <li
            class="picker-item"
            v-for="(pick, index) in pickData"
            :key="index"
            :style="pick.style"
            @click="itemSelect(pick)"
            :class="{ on: checkedTags.includes(pick.value) }"
        >
            {{ pick.label }}
        </li>
    </ul>
</template>

<script>
export default {
    name: "SwitchTabs",
    props: ["pickData", "current"],
    data() {
        return {
            checkedTags: this.current || []
        };
    },
    watch: {
        current() {
            this.checkedTags = this.current || [];
        }
    },
    methods: {
        itemSelect(pickItem) {
            if (!this.checkedTags.includes(pickItem.value)) {
                this.checkedTags.indexOf(pickItem.value) === -1 && this.checkedTags.push(pickItem.value);
            } else {
                let itemcheckedIdx = this.checkedTags.indexOf(pickItem.value);
                itemcheckedIdx !== -1 && this.checkedTags.splice(itemcheckedIdx, 1);
            }

            this.$emit("userChange", this.checkedTags);
        }
    }
};
</script>

<style lang="less" scoped>
.switch-tab-wrapper {
    padding: 0;
    box-sizing: border-box;

    .picker-item {
        position: relative;
        display: inline-block;
        padding: 0 10px;
        min-width: 80px;
        margin: 0 8px 8px 0;
        height: 32px;
        line-height: 30px;
        box-sizing: border-box;
        border: 1px solid #d8e4f0;
        border-radius: 4px;
        text-align: center;
        font-size: 12px;
        box-sizing: border-box;
        cursor: pointer;
        &:hover,
        &.on {
            border-color: #2ec2ff;
        }
        &.on:after {
            position: absolute;
            right: 0;
            bottom: -1px;
            width: 24px;
            height: 22px;
            content: "";
            display: block;
            background: url("@{zhijiStaticImagePath}class-spr.png") -35px -52px;
        }
    }
}
</style>
